import { lazy } from "react";
import { BsBarChartLine } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FiFileText } from "react-icons/fi";
import { IoGridOutline } from "react-icons/io5";
import { LuUser } from "react-icons/lu";
import { MdCreditCard, MdOutlineHomeRepairService } from "react-icons/md";
import { PiUsersThree } from "react-icons/pi";
import { TbCategoryPlus } from "react-icons/tb";

const Notifications = lazy(() => import("../pages/Notifications"));
const ProfileSettings = lazy(() => import("../pages/ProfileSettings"));
const Cms = lazy(() => import("../pages/Cms"));
const Login = lazy(() => import("../pages/Login"));
const GoferManagement = lazy(() => import("../pages/GoferManagement"));
const UserDetails = lazy(() => import("../pages/UserDetails"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const ClientManagement = lazy(() => import("../pages/ClientManagement"));
const TransactionManagement = lazy(() =>
  import("../pages/TransactionManagement")
);
const ReportsAndAnalytics = lazy(() => import("../pages/ReportsAndAnalytics"));
const ServicesManagement = lazy(() => import("../pages/ServicesManagement"));
const CrudManagement = lazy(() => import("../pages/CrudManagement"));

export const routes = [
  {
    path: "/login",
    exact: true,
    element: <Login />,
    protected: false,
    showInSidebar: false,
  },
  {
    path: "/",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Dashboard",
    element: <Dashboard />,
    icon: <IoGridOutline />,
  },
  {
    path: "/gofer-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Gofer Management",
    element: <GoferManagement />,
    icon: <LuUser />,
  },
  {
    path: "/gofer-management/:id",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "User Details",
    element: <UserDetails />,
  },
  {
    path: "/client-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Client Management",
    element: <ClientManagement />,
    icon: <PiUsersThree />,
  },
  {
    path: "/services-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Services Management",
    element: <ServicesManagement />,
    icon: <MdOutlineHomeRepairService />,
  },
  {
    path: "/transaction-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Transactions",
    element: <TransactionManagement />,
    icon: <MdCreditCard />,
  },
  {
    path: "/reports-and-analytics",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Reports and Analytics",
    element: <ReportsAndAnalytics />,
    icon: <BsBarChartLine />,
  },
  {
    path: "/crud-management",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Crud Management",
    element: <CrudManagement />,
    icon: <FiFileText />,
  },
  {
    path: "/cms",
    exact: true,
    protected: true,
    showInSidebar: true,
    title: "Cms",
    element: <Cms />,
    icon: <TbCategoryPlus />,
  },
  {
    path: "/profile",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Profile",
    icon: <CgProfile />,
    element: <ProfileSettings />,
  },
  {
    path: "/notifications",
    exact: true,
    protected: true,
    showInSidebar: false,
    title: "Notifications",
    element: <Notifications />,
  },
];
